// extracted by mini-css-extract-plugin
var _1 = "UserItem_menuItem__lin5F";
var _2 = "UserItem_menuItemText__5jLX0";
var _3 = "UserItem_menuItemTextActive__4SjtK";
var _4 = "UserItem_user__b-Am+";
export { _1 as "menuItem", _2 as "menuItemText", _3 as "menuItemTextActive", _4 as "user" }
